import { ChapterProgressDto } from './chapter-progress.model';
import { ChapterProgress } from '@lyceo/lyceo-pupil-app/practise/util-models';

export function mapChapterProgress(
  chapterProgressDto: ChapterProgressDto,
): ChapterProgress {
  return {
    id: chapterProgressDto.id,
    bookId: chapterProgressDto.bookId,
    chapterId: chapterProgressDto.chapterId,
    paragraphsCompleted: chapterProgressDto.paragraphsCompleted,
    totalParagraphs: chapterProgressDto.totalParagraphs,
    completed: chapterProgressDto.completed,
  };
}
